import ApplicationAdapter from 'lumen/adapters/application';

export default class SmartInsightsSmartInsightDayAdapter extends ApplicationAdapter {
  pathForType(modelName: string): string {
    // By default, Ember Data pluralises the last segment of the typeKey.
    // This causes `smartinsights/insights/archive` to become `smartinsights/insights/archives`.
    // Return the name as-is since the typeKey already contains the correct path.
    return modelName;
  }
}
